import { INVOICE, PRZELEWY24 } from '@constants/paymentMethods'
import { newLandingiClient } from '@lib/http/client'

type PaymentMethodTypes = typeof INVOICE | typeof PRZELEWY24

interface GetPaymentsProviderResponse {
  name: PaymentMethodTypes
  url: string
}

export const getPaymentsProvider = async (csrfToken: string) => {
  const response = await newLandingiClient.get<GetPaymentsProviderResponse>(
    '/payments/provider',
    {
      headers: {
        'X-CSRF-TOKEN': csrfToken
      }
    }
  )

  return response.data
}
